export default __webpack_public_path__ + "static/media/addpitcher.3b41201f.jpg";